import { render } from "./MenuButton.vue?vue&type=template&id=5b5fc26e&scoped=true"
import script from "./MenuButton.vue?vue&type=script&lang=ts"
export * from "./MenuButton.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-5b5fc26e"

export default script